export default "/images/715d4c2af51472adccd3ee64e1100b2c.avif";